"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Engine = void 0;
const protocol_1 = require("../protocol");
const constants_1 = require("./constants");
const utils_1 = require("../utils");
const iconnector_1 = require("../connector/iconnector");
const connectionManager_1 = require("./connectionManager");
const sessionUtils_1 = require("./sessionUtils");
const wallet_info_1 = require("../protocol/connect/wallet-info");
class Engine {
    constructor(appName) {
        this.connectors = [];
        this.useConnector = undefined;
        this.sessionRetryTimer = null;
        this.connectionManager = new connectionManager_1.ConnectionManager(appName);
        this.addConnectionListener();
    }
    getConnector() {
        if (this.useConnector) {
            return this.useConnector;
        }
    }
    setAccountChangeListener(accountChangeListener) {
        this.accountChangeListener = accountChangeListener;
        (0, utils_1.logDebug)("setAccountChangeListener: engine", accountChangeListener);
        for (const connector of this.connectors) {
            connector.setAccountChangeListener(accountChangeListener);
        }
    }
    registerConnector(connectors) {
        this.connectors = connectors;
        for (const connector of connectors) {
            connector.setConnectionManager(this.connectionManager);
        }
        if (this.accountChangeListener) {
            this.setAccountChangeListener(this.accountChangeListener);
        }
    }
    getAllConnectors() {
        return this.connectors;
    }
    hasWsConnector() {
        for (const connector of this.connectors) {
            if (this.isWsConnector(connector)) {
                return true;
            }
        }
        return false;
    }
    isWsConnector(connector) {
        if (!connector)
            return false;
        return Object.values(iconnector_1.CONNECTOR_TYPE.WS).includes(connector.getType());
    }
    isInjectedConnector(connector) {
        if (!connector)
            return false;
        return Object.values(iconnector_1.CONNECTOR_TYPE.INJECT).includes(connector.getType())
            || Object.values(iconnector_1.CONNECTOR_TYPE.KEYLESS).includes(connector.getType());
    }
    universalConnect(request, sessionConfig, connectInfoAndUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            this.addConnectionListener();
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e;
                try {
                    (0, utils_1.logDebug)("engine universalConnect request :", JSON.stringify(request));
                    (0, utils_1.logDebug)("engine universalConnect sessionConfig :", JSON.stringify(sessionConfig));
                    let universalRequest = [];
                    request.forEach((item) => {
                        let name = item.name;
                        if (name.startsWith("requestAccounts") || name.startsWith("ton")) {
                            universalRequest.push(item);
                        }
                    });
                    (0, utils_1.logDebug)("engine universalConnect universalRequest :", JSON.stringify(universalRequest));
                    const connectInfo = this.connectionManager.getConnectInfo();
                    const requestId = Date.now().toString();
                    let openUniversalLink = (_a = sessionConfig.openUniversalUrl) !== null && _a !== void 0 ? _a : false;
                    let linkType = (_b = sessionConfig.openAppLinkType) !== null && _b !== void 0 ? _b : protocol_1.OpenAppLinkType.UniversalLink;
                    const universalConnectRequest = {
                        protocolVer: Number(protocol_1.tonConnectSdkVersion),
                        topic: connectInfo.channelId,
                        clientId: connectInfo.clientId,
                        requestId: requestId,
                        dAppInfo: this.fixDappName(sessionConfig.dappInfo),
                        requests: universalRequest,
                        redirect: (_c = sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.redirect) !== null && _c !== void 0 ? _c : "none"
                    };
                    const base64Encoded = (0, utils_1.encodeConnectParams)(universalConnectRequest);
                    universalConnectRequest.redirect = (_d = sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.redirect) !== null && _d !== void 0 ? _d : "none";
                    (0, utils_1.logDebug)('engine universalConnect ==>>universalConnectRequest:', JSON.stringify(universalConnectRequest));
                    let universalLink = "";
                    let deepLink = "";
                    if (openUniversalLink) {
                        let linkInfo = (0, utils_1.getOKXLink)(universalConnectRequest, sessionConfig.useMini, sessionConfig.tmaReturnUrl);
                        universalLink = linkInfo.universalLink;
                        deepLink = linkInfo.deepLink || "";
                        (0, utils_1.logDebug)('engine universalConnect ==>>openOKXLink:', universalLink);
                    }
                    const openMethod = () => {
                        if (this.connectors.length == 1 && this.isInjectedConnector(this.connectors[0])) {
                            return this.connectors[0].openWallet({
                                connectRequest: universalConnectRequest,
                            }, linkType);
                        }
                        else {
                            if (sessionConfig.useMini) {
                                return (0, utils_1.openOKXTMAWalletlinkWithFallback)(universalLink);
                            }
                            return (0, utils_1.openOKXDeeplinkWithFallback)(deepLink, universalLink, linkType);
                        }
                    };
                    (0, utils_1.logDebug)('engine universalConnect ==>>openOKXLink:', universalLink);
                    const isIOS = (0, utils_1.isIos)();
                    if (isIOS && openUniversalLink) {
                        (0, utils_1.logDebug)(`engine universalConnect ==>>isIOS: ${isIOS}   openUniversalLink: ${openUniversalLink}`);
                        openMethod();
                    }
                    this.addOnConnectResultListener((response, connector) => {
                        var _a, _b, _c, _d;
                        try {
                            this.stopSendSessionRetry();
                            this.addOnConnectResultListener(undefined);
                            let connectResponse = response;
                            if (connectResponse.method == "connect") {
                                (0, utils_1.logDebug)("engin  universalConnect success connectResponse:>>>", JSON.stringify(connectResponse));
                                let namespaces = (0, sessionUtils_1.buildNameSpacesByConnectResponse)(connectResponse);
                                if (namespaces) {
                                    let walletName = undefined;
                                    if (((_b = (_a = connectResponse.payload) === null || _a === void 0 ? void 0 : _a.responses) === null || _b === void 0 ? void 0 : _b[0]) && "walletName" in connectResponse.payload.responses[0]) {
                                        walletName = connectResponse.payload.responses[0]['walletName'];
                                    }
                                    let appName = (_c = connectResponse.payload) === null || _c === void 0 ? void 0 : _c.wallet.appName;
                                    //for ws connector;
                                    var tag = "";
                                    switch (appName) {
                                        case wallet_info_1.OKXWalletName:
                                            tag = iconnector_1.OKX_APP_WALLET;
                                            break;
                                        case wallet_info_1.OKXMiniWalletName:
                                            tag = iconnector_1.OKX_TG_WALLET;
                                            break;
                                    }
                                    var realConector;
                                    if (connector) {
                                        realConector = connector;
                                    }
                                    else if (tag) {
                                        realConector = this.connectors.find((connector) => connector.getTag() === tag);
                                    }
                                    if (!realConector) {
                                        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR);
                                    }
                                    let session = Object.assign({ topic: connectInfo.channelId, sessionConfig: sessionConfig, namespaces: namespaces }, (connectResponse.payload && {
                                        wallet: Object.assign(Object.assign({}, connectResponse.payload.wallet), { walletName: walletName })
                                    }));
                                    let methodsResponse = connectResponse.payload.responses.find(item => item.name === 'requestAccounts');
                                    if (methodsResponse && methodsResponse.connectRequestMethods) {
                                        session.signResponse = methodsResponse.connectRequestMethods;
                                    }
                                    (0, utils_1.logDebug)("engin  universalConnect success session:>>>", JSON.stringify(session));
                                    if (this.isWsConnector(realConector)) {
                                        (0, utils_1.logDebug)("engine update protocol version");
                                        this.connectionManager.updateProtocolVersion(connectInfo.channelId, connectResponse.payload.wallet.maxProtocolVersion);
                                    }
                                    this.deviceInfo = Object.assign({}, session.wallet);
                                    resolve(session);
                                    this.setUseConnector(realConector);
                                    (0, utils_1.reportEvent)(utils_1.OKXReportType.PAGE_IN, utils_1.Report_OKXConnectSDKExtension_ConnectDapp_ConnectSuccess_View, tag);
                                }
                                else {
                                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR);
                                }
                            }
                            else if (connectResponse.method == "connect_error" && ((_d = connectResponse.payload) === null || _d === void 0 ? void 0 : _d.code) != undefined) {
                                throw new protocol_1.OKXConnectError(connectResponse.payload.code);
                            }
                        }
                        catch (e) {
                            reject(e);
                        }
                    });
                    if (this.hasWsConnector()) {
                        yield ((_e = this.connectionManager) === null || _e === void 0 ? void 0 : _e.disconnect(false));
                        try {
                            yield this.connectionManager.connect();
                        }
                        catch (e) {
                            (0, utils_1.logDebug)('Engine universalConnect error', e);
                            throw e;
                        }
                        (0, utils_1.logDebug)('engin  universalConnect ==>> connectInfoAndUrl:', connectInfoAndUrl);
                        this.sendSession(base64Encoded, universalConnectRequest.topic, openUniversalLink);
                    }
                    if (!isIOS && openUniversalLink) {
                        openMethod();
                    }
                    (0, utils_1.logDebug)('engin  universalConnect ==>> connectInfoAndUrl:', connectInfoAndUrl);
                    if (connectInfoAndUrl) {
                        const info = {
                            connectRequest: universalConnectRequest,
                            redirect: sessionConfig.redirect,
                            tmaReturnUrl: sessionConfig.tmaReturnUrl,
                        };
                        (0, utils_1.logDebug)("universalConnect connectInfoAndUrl info :", JSON.stringify(info));
                        connectInfoAndUrl(info);
                    }
                }
                catch (error) {
                    (0, utils_1.logDebug)("Engine universalConnect catch error", error);
                    reject(error);
                }
            }));
        });
    }
    fixDappName(dappInfo) {
        try {
            if (dappInfo.name.toLowerCase() === 'dapp portal') {
                let title = document.title;
                if (!title) {
                    title = this.getOGSiteName();
                }
                if (title) {
                    return Object.assign(Object.assign({}, dappInfo), { name: dappInfo.name + " - " + title });
                }
            }
            return dappInfo;
        }
        catch (e) {
            return dappInfo;
        }
    }
    getOGSiteName() {
        let metas = document.getElementsByTagName('meta');
        let objectTitleList = ["og:site_name", "og:title", "twitter:title"];
        for (let meta of metas) {
            let property = meta.getAttribute('property');
            for (let objectTitle of objectTitleList) {
                if (property == objectTitle) {
                    return meta.getAttribute("content");
                }
            }
        }
        return undefined;
    }
    addOnConnectResultListener(connectResultListener) {
        for (const connector of this.connectors) {
            if (this.isInjectedConnector(connector)) {
                connector.setOnConnectResultListener(connectResultListener);
            }
        }
        this.connectResultListener = connectResultListener;
    }
    openWallet(engineConnectInfo, connector, openAppLinkType) {
        var _a;
        if (connector) {
            connector.openWallet(engineConnectInfo, openAppLinkType);
        }
        else {
            (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.openWallet(engineConnectInfo, openAppLinkType);
        }
    }
    send(request, requestAnswer, ttl) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            let chainId;
            if ('chainId' in request && request.chainId != null) {
                chainId = request.chainId.toString();
            }
            try {
                (0, utils_1.reportEvent)(utils_1.OKXReportType.LOG, utils_1.Report_OKXConnectSDK_RequestStart_Log, "", (_b = (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.getTag()) !== null && _b !== void 0 ? _b : '', request.method, (_d = (_c = this.deviceInfo) === null || _c === void 0 ? void 0 : _c.platform) !== null && _d !== void 0 ? _d : "", chainId);
                if (!this.getConnector()) {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.NOT_CONNECTED_ERROR);
                }
                (_e = this.getConnector()) === null || _e === void 0 ? void 0 : _e.send(request, {
                    resolve: (response) => {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                        (_a = requestAnswer === null || requestAnswer === void 0 ? void 0 : requestAnswer.resolve) === null || _a === void 0 ? void 0 : _a.call(requestAnswer, response);
                        if (('error' in response) && response.error) {
                            (0, utils_1.reportEvent)(utils_1.OKXReportType.LOG, utils_1.Report_OKXConnectSDK_RequestError_Log, "", (_c = (_b = this.getConnector()) === null || _b === void 0 ? void 0 : _b.getTag()) !== null && _c !== void 0 ? _c : '', request.method, (_e = (_d = this.deviceInfo) === null || _d === void 0 ? void 0 : _d.platform) !== null && _e !== void 0 ? _e : "", chainId);
                        }
                        else {
                            (0, utils_1.reportEvent)(utils_1.OKXReportType.LOG, utils_1.Report_OKXConnectSDK_RequestSuccess_Log, "", (_g = (_f = this.getConnector()) === null || _f === void 0 ? void 0 : _f.getTag()) !== null && _g !== void 0 ? _g : '', request.method, (_j = (_h = this.deviceInfo) === null || _h === void 0 ? void 0 : _h.platform) !== null && _j !== void 0 ? _j : "", chainId);
                        }
                    },
                    onAck: () => {
                        var _a;
                        (_a = requestAnswer === null || requestAnswer === void 0 ? void 0 : requestAnswer.onAck) === null || _a === void 0 ? void 0 : _a.call(requestAnswer);
                    }
                });
            }
            catch (error) {
                (0, utils_1.reportEvent)(utils_1.OKXReportType.LOG, utils_1.Report_OKXConnectSDK_RequestError_Log, "", (_g = (_f = this.getConnector()) === null || _f === void 0 ? void 0 : _f.getTag()) !== null && _g !== void 0 ? _g : '', request.method, (_j = (_h = this.deviceInfo) === null || _h === void 0 ? void 0 : _h.platform) !== null && _j !== void 0 ? _j : "", chainId);
                throw error;
            }
        });
    }
    clearData() {
        var _a;
        (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.clearData();
    }
    addDisconnectListener(disconnecter) {
        var _a;
        (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.addDisconnectListener(disconnecter);
    }
    saveSessionContent(key, data) {
        this.connectionManager.saveSessionContent(key, data);
    }
    getSessionContent(key) {
        var _a;
        var session = this.connectionManager.getSessionContent(key);
        if (session) {
            var tag = "";
            if (typeof session === "object") {
                tag = (0, iconnector_1.getTagByappName)((_a = session.wallet) === null || _a === void 0 ? void 0 : _a.appName);
            }
            if (this.connectors.find((connector) => {
                return connector.getTag() === tag;
            })) {
                return session;
            }
        }
        return undefined;
    }
    setConnectConnector(wallet) {
        var tag = (0, iconnector_1.getTagByappName)(wallet === null || wallet === void 0 ? void 0 : wallet.appName);
        if (!tag)
            return;
        this.setUseConnector(this.connectors.find((connector) => {
            return connector.getTag() === tag;
        }));
    }
    setUseConnector(connector) {
        this.useConnector = connector;
        if (this.isWsConnector(connector)) {
            connector.addConnectionListener();
        }
    }
    // for es connect
    setSessionConnectingListener(sessionConnectingListener) {
        this.sessionConnectingListener = sessionConnectingListener;
    }
    restoreconnect(sessionInfo, onConnectResult) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.getConnector()) {
                this.getConnector().restoreconnect(sessionInfo, (session) => {
                    var _a, _b;
                    onConnectResult(session);
                    if (session) {
                        this.deviceInfo = Object.assign({}, session.wallet);
                        (0, utils_1.reportEvent)(utils_1.OKXReportType.PAGE_IN, utils_1.Report_OKXConnectSDKExtension_ConnectDapp_ConnectSuccess_View, (_b = (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.getTag()) !== null && _b !== void 0 ? _b : '');
                    }
                });
            }
            else {
                onConnectResult(null);
            }
        });
    }
    restoreconnectFromTopic(topic) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isWsConnector(this.getConnector())) {
                yield this.getConnector().restoreconnectFromTopic(topic);
            }
        });
    }
    getCurrentConnectionReady(namespaceKeys) {
        var _a;
        return !!((_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.getCurrentConnectionReady(namespaceKeys));
    }
    connectManagerDisconnect() {
        return __awaiter(this, arguments, void 0, function* (fromRestore = false) {
            var _a, _b;
            if (this.getConnector()) {
                (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.connectManagerDisconnect(fromRestore);
            }
            else {
                yield ((_b = this.connectors.find(connector => this.isWsConnector(connector))) === null || _b === void 0 ? void 0 : _b.connectManagerDisconnect(fromRestore));
            }
            this.stopSendSessionRetry();
            this.setUseConnector(undefined);
        });
    }
    sendSession(sessionInfo, topic, openUniversalLink) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, utils_1.logDebug)('[Connect] sendSession called:', sessionInfo);
            const requestId = Date.now().toString();
            let request = {
                method: 'session_info',
                params: { protocolVersion: constants_1.CONNECT_PROTOCOL_VER, sessionInfo: sessionInfo }
            };
            yield this.connectionManager.sendRaw(JSON.stringify(Object.assign(Object.assign({}, request), { requestId: requestId })));
            if (this.sessionRetryTimer) {
                clearInterval(this.sessionRetryTimer);
            }
            if (!openUniversalLink) {
                // connect msg retry
                this.sessionRetryTimer = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                    const retryRequestId = Date.now().toString();
                    (0, utils_1.logDebug)('[Connect] Retrying sendSession...');
                    yield this.connectionManager.sendSubscribe(topic);
                    yield this.connectionManager.sendRaw(JSON.stringify(Object.assign(Object.assign({}, request), { requestId: retryRequestId })));
                }), constants_1.OKXCONNECTOR_MESSAGE_TTL);
            }
        });
    }
    stopSendSessionRetry() {
        if (this.sessionRetryTimer) {
            clearInterval(this.sessionRetryTimer);
            this.sessionRetryTimer = null;
            (0, utils_1.logDebug)('[Connect] Stopped retry for session');
        }
    }
    addConnectionListener() {
        var _a;
        (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.addListener("sdk_response", (event, msg) => {
            var jsonResponse = (0, utils_1.safeJsonParse)(msg);
            (0, utils_1.logDebug)(`Engine ==>> addListener ==> success ==> ${jsonResponse}`);
            if (jsonResponse.method === 'connect') {
                if (this.connectResultListener) {
                    this.connectResultListener(jsonResponse);
                }
            }
            else if (jsonResponse.method === 'connect_error') {
                this.connectManagerDisconnect(false)
                    .catch(() => { })
                    .finally(() => {
                    if (this.connectResultListener) {
                        this.connectResultListener(jsonResponse);
                    }
                });
            }
            else if (jsonResponse.method === "session_connecting") {
                (0, utils_1.logDebug)("Engine ==>> handleResponse_4  ===> sessionConnectingListener");
                if (this.sessionConnectingListener) {
                    (0, utils_1.logDebug)("Engine ==>> handleResponse_4  ===> sessionConnectingListener not null");
                    this.sessionConnectingListener();
                    this.sessionConnectingListener = undefined;
                }
            }
        }, function () {
        });
    }
}
exports.Engine = Engine;
